<template>
  <div>
    <el-popover placement="top" trigger="hover">

      <div v-for="(value, key) in rowData.receivers" :key="key">
        <li v-if="value == '确认'" v-bind:style="{ backgroundColor: '#1bec80' }">
          {{ key }}:{{ "Approved" }}
        </li>
        <li v-else-if="value == '未确认'" :style="{ backgroundColor: '#f3f334' }">
          {{ key }}:{{ "Pending" }}
        </li>
        <li v-else-if="value == '拒绝'" :style="{ backgroundColor: '#f76d87' }">
          {{ key }}:{{ "Rejected" }}
        </li>
      </div>

      <div slot="reference" v-bind:style="styleobj.thestyle">{{ styleobj.label }}</div>

    </el-popover>
  </div>
</template>

<script>
import palette from "google-palette";
export default {
  props: ["rowData", "rowField"],
  mounted() {
  },
  data() {
    return {

    }
  },
  computed: {
    styleobj() {
      let stylerules = JSON.parse(JSON.stringify(this.rowField.stylerules))
      let status = this.rowData.status

      let thestyle = {}
      let label = "Pending"

      //eval会用到的
      let rowData = this.rowData;
     
      let i = stylerules.findIndex((obj) => {
        return eval(obj.judge)//obj.score[1] >= status && obj.score[0] <= status
      })


      if (i > -1) {
        thestyle = stylerules[i].style
        //如未指定颜色，可自动颜色
        if (!thestyle.backgroundColor) {
          // console.log(thestyle.backgroundColor)
         let x = parseInt(this.rowData.status)//this.fncolor()
         thestyle.backgroundColor=this.fncolor(x)//this.fncolor(x)
        }
        label = stylerules[i].label
      }

      else {
        let self = this
        let bccolor = this.fncolor(parseInt(self.rowData.status))//this.rowData.status
        // console.log(bccolor)
        label = "Pending"
        thestyle = { color: "red", backgroundColor: bccolor }
      }

      let styleobj = { thestyle: thestyle, label: label }

      return styleobj

    },


    // content() {
    //   let receivers = this.rowData.receivers || { None: "None" };
    //   let content = "";
    //   for (let key in receivers) {
    //     content = content + key + ":" + receivers[key] + "\n";
    //   }
    //   return content;
    // },
  },
  methods: {
    fncolor(status) {
      return "#" + palette("cb-YlGn", 8)[status];
    },
  },
};
</script>

<style scoped>
/* .el-button{ padding:0;} */
</style>


// WEBPACK FOOTER //
// src/components/utility/commonfields/status.vue